<template>
  <div class="BusinessMetrics">
    <Card :title="$t('business.total')">
      <CounterDisplay :value="metrics.totalBusinesses" icon="target" />
    </Card>
    <Card :title="$t('business.new')">
      <CounterDisplay :value="metrics.newBusinesses" icon="new" class="icon" />
    </Card>
    <Card :title="$t('business.discharged')">
      <CounterDisplay :value="metrics.droppedBusinesses" icon="discharged" />
    </Card>
  </div>
</template>

<script>
import { Icon } from 'daas-components';

import { getBusinessMetrics } from '@/api';

import { Card, CounterDisplay } from '@/components';

export default {
  name: 'BusinessMetrics',
  data() {
    return {
      metrics: {},
    };
  },
  components: {
    Icon,
    Card,
    CounterDisplay,
  },
  created() {
    getBusinessMetrics().then(
      data => {
        this.metrics = data;
      },
      err => {
        console.log('Fetch Error: ', err);
      }
    );
  },
};
</script>

<style lang="scss">
.BusinessMetrics {
  display: flex;
  justify-content: center;
  .Card {
    margin-right: rem(10);
    margin-left: rem(10);
    width: rem(250);
    max-width: rem(300);
  }
}
</style>
